import React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';

export const ImageModal = ({ imagesList }) => {
  const getCleanUrl = (url) => {
    return url?.startsWith('blob:') ? url : `${url}?w=800&fit=crop&auto=format`;
  };

  return (
    <ImageList
      sx={{
        width: '100%',
        height: 350,
        overflowY: 'auto',
        padding: 1,
      }}
      cols={1}
      gap={16}
    >
      {imagesList.map((item, idx) => (
        <ImageListItem key={idx}>
          <img
            src={getCleanUrl(item?.url || '')}
            alt={item?.file_name || ''}
            loading="lazy"
            style={{
              width: '100%',
              height: 'auto',
              borderRadius: 4,
            }}
          />
          <ImageListItemBar
            title={item?.file_name || ''}
            subtitle={<span>by: {item?.updated_by || ''}</span>}
            position="below"
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
};

